// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-restricted-syntax */
/* ONLY provide colors in following formats:
 - rgb(x,x,x)
 - #XXXXXX
 */

const customColors = {
  check: 'rgb(167,66,255)',
  felyx: 'rgb(6,81,41)',
  vecore: 'rgb(255,176,2)',
  greenwheels: 'rgb(49,170,82)',
  greenwheels_commission: 'rgba(49,170,82,0.5)',
  greenwheels_rnp: 'rgb(19, 111, 44)',
  greenwheels_rnp_commission: 'rgba(19,111,44,0.5)',
  adyen: 'rgb(178,0,0)',
  ns: 'rgb(0,2,92)',
  mrr: 'rgb(93,2,2)',
  usage_fee: 'rgb(255,99,132)',
  mywheels: 'rgb(27,112,222)',
  mywheels_commission: 'rgba(27,112,222,0.5)',
  amber: 'rgb(226,122,18)',
} as const;

type CustomColor = (typeof customColors)[keyof typeof customColors];

export { type CustomColor, customColors };
